import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import AreaAddressRenderer from 'timeSheet/components/CellRenderers/AreaAddressRenderer';

const useShiftAreaAddressColumn = ({ mappedLocations }) => {
  const { t } = useContext(ConfigContext);

  const valueGetter = useCallback((params) => mappedLocations?.[params.data?.locationId]?.address || '', [
    mappedLocations
  ]);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return AreaAddressRenderer({
        rowData: params.data,
        columnData: { mappedLocations }
      });
    },
    [mappedLocations]
  );

  return useMemo(
    () => ({
      field: 'address',
      headerName: t('address'),
      cellClass: 'justify-start',
      width: 350,
      valueGetter,
      cellRenderer
    }),
    [t, valueGetter, cellRenderer]
  );
};

export default useShiftAreaAddressColumn;
